<template>
  <section class="secen_helper_29" ref="secen_helper_29">
    <div class="content_box" ref="content_box">
      <div
        class="title-box-29"
        bg-url="@/auto/assets/image/29/title_2x.png"
        v-bg
      ></div>
      <div class="font-box-29">
        <p>
          基于Al大模型与传统语音能力深度融合具备丰富且实用的语音应用重新定义语音助理
        </p>
        <p>为你带来更加便捷，高效、智能的自然语音交互体验</p>
      </div>
      <div
        class="img_box img1_29"
        bg-url="@/auto/assets/image/big-model1.png"
        v-bg
      ></div>
      <div
        class="img_box img2_29"
        bg-url="@/auto/assets/image/big-model2.png"
        v-bg
      ></div>
    </div>
    <!-- <div class="seat"></div> -->
  </section>
</template>

<script>
export default {
  name: 'SecenHelper',
  data() {
    return {
      startAnimation: false,
    }
  },
  watch: {
    startAnimation(val) {
      if (val) {
        const that = this
        const tl = this.$gsap.timeline({
          scrollTrigger: {
            trigger: '.secen_helper_29',
            start: 'center-100 bottom',
            end: 'bottom top',
            scrub: 0.1,
            // markers: true,
            // pin:true,
            // onUpdate(self) {
            //   console.log(self, '-=-=-', that.$refs.secen_helper_29.scrollTop)
            // },
          },
        })
        tl.addLabel('img')
        tl.to('.img1_29', { right: '-200px' }, 'img')
        tl.to('.img2_29', { left: '-200px' }, 'img')
      }
    },
  },
  methods: {
    onLaunch() {
      window.addEventListener('scroll', () => {
        // console.log(
        //   this.$refs?.secen_helper_29.getBoundingClientRect().top,
        //   'that.$refs.secen_helper_29.scrollTop',
        // )
        // console.log('滚动高度：' + window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop);
        if (this.$refs?.secen_helper_29.getBoundingClientRect().top < 900) {
          this.startAnimation = true
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.seat {
  height: 3000px;
  width: 100%;
}
.secen_helper_29 {
  // height: 100vh;
  min-height: 1080px;
  width: 100%;
  background-color: #17181c;
  overflow: hidden;
  position: relative;
  // position: sticky;
  // top: 0;
  // border: 1px solid #f00;
  z-index: 99999;

  .content_box {
    width: 100vw;
    height: 100vh;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
  .font-box-29 {
    width: 1090px;
    position: absolute;
    top: 270px;
    left: 50%;
    transform: translateX(-50%);
    > p {
      color: rgba(255, 255, 255, 0.6);
      text-align: center;
      font-family: Flyme Sans VF;
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: 36px; /* 142.857% */
      letter-spacing: 1.4px;
    }
  }
  .title-box-29 {
    position: absolute;
    top: 130px;
    left: 50%;
    transform: translateX(-50%);
    width: 630px;
    height: 108px;
    background-size: 100%;
  }

  .img_box {
    position: absolute;
    width: 4196px;
    height: 352px;
    background-repeat: no-repeat;
    transition: right 0.3s linear;
    transform: translateZ(0);
  }
  .img1_29 {
    top: 426px;
    // right: 250px;
    right: 0px;
    background-size: 70% 70%;
    background-position-x: 100%;
  }
  .img2_29 {
    top: 696px;
    // left: 250px;
    left: 0px;
    background-size: 70%;
    background-position: 0 0;
  }
}
</style>
